<script>
import resources from './resources'
import { TheMask } from 'vue-the-mask'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'patient-register-form',
  mixins: [resources],
  components: {
    TheMask
  }
}
</script>

<template lang="pug">
.authentication
  page
  .container
    .col-md-12.content-center
      .modal-backdrop(v-if="isShowing")
      .modal(
        style='z-index: 1040; padding-right: 15px; display: block;',
        aria-modal='true',
        v-show="isShowing"
        :class="{'modal-mobile': isMobiled}"
      )

        .modal-dialog(role='document')
          .modal-content
            .modal-header
              h4#defaultModalLabel.title Regimento Interno
              button.close(type='button', data-dismiss='modal', aria-label='Close', @click.prevent="doHide()")
                span(aria-hidden='true') ×

            .modal-body
              div#scroll-content
                #content-notice.modal-body(v-html="terms")
            .modal-footer
      .row
        .col-lg-6.col-md-12
            .company_detail
                h4.logo
                  router-link(:to="{name: 'auth.login'}")
                    img(src='/static/images/logo.svg', alt='')
                  br
                  span(style="font-size: 18px;") Condomum

                  //-ul.social_link.list-unstyled
                    li
                      a(href='https://thememakker.com', title='ThemeMakker')
                        i.zmdi.zmdi-globe
                    li
                      a(href='https://themeforest.net/user/thememakker', title='Themeforest')
                        i.zmdi.zmdi-shield-check
                    li
                      a(href='https://www.linkedin.com/company/thememakker/', title='LinkedIn')
                        i.zmdi.zmdi-linkedin
                    li
                      a(href='https://www.facebook.com/thememakkerteam', title='Facebook')
                        i.zmdi.zmdi-facebook
                    li
                      a(href='http://twitter.com/thememakker', title='Twitter')
                        i.zmdi.zmdi-twitter
                    li
                      a(href='http://plus.google.com/+thememakker', title='Google plus')
                        i.zmdi.zmdi-google-plus
                    li
                      a(href='https://www.behance.net/thememakker', title='Behance')
                        i.zmdi.zmdi-behance
                  hr
                  //-ul
                    li
                      a(href='http://thememakker.com/contact/', target='_blank') Contato
                    li
                      a(href='http://thememakker.com/about/', target='_blank') Sobre
                    li
                      a(href='http://thememakker.com/services/', target='_blank') Serviços
                    li
                      a(href='javascript:void(0);') FAQ
        .col-lg-5.col-md-12.offset-lg-1(v-if="!next")
          .card-plain
            .header
              h5
              span Informe o código do seu condominio

            .form
              .input-group
                input.form-control(
                  type='text',
                  v-model="check.tenant_id",
                  autocomplete="off",
                  maxlength="7",
                  placeholder='YYYYXXX'
                )
                span.input-group-addon
                  i.zmdi.zmdi-balance
            .footer
              a.btn.btn-primary.btn-round.btn-block(
                 @click.prevent="doCheck()"
              ) LOCALIZAR
            router-link.link(:to="{ name: 'auth.login'}") Você já tem cadastro

        .col-lg-5.col-md-12.offset-lg-1(v-if="next")
          .card-plain
            .header
              h6 {{ tenant.name }}
            .form
              v-input(:status="$v.register.name.$error ? 'error' : null")
                .input-group
                  input.form-control(
                    type='text',
                    v-model="register.name"
                    placeholder='Nome completo')
                  span.input-group-addon
                    i.zmdi.zmdi-account-circle
              v-input(:status="$v.register.email.$error ? 'error' : null")
                .input-group
                  input.form-control(
                    type='text',
                    v-model="register.email"
                    placeholder='Informe seu email'
                  )
                  span.input-group-addon
                    i.zmdi.zmdi-email
              v-input(:status="$v.register.genre.$error ? 'error' : null")
                .input-group
                  f-select(
                    id="unit_id",
                    name="tower",
                    track-by="id",
                    label-by="name",
                    v-model="register.genre",
                    :options="optionsGenre",
                    :searchable="true",
                    :multiple="false",
                    placeholder='Sexo',
                    openDirection="bottom",
                    style="width: 100%;"
                  )
                // v-select(
                //   v-model="register.genre"
                //   as="name::id"
                //   :from="optionsGenre"
                //   tagging
                //   placeholder="Sexo"
                //   @change="setGenre($event)"
                // )

              v-input(:status="$v.register.phone.$error ? 'error' : null")
                .input-group
                  the-mask.form-control(
                    :mask="['(##) ####-####','(##) #####-####']",
                    name='text',
                    type='text',
                    placeholder='(00) 9 0000-0000'
                    v-model="register.phone"
                    autocomplete="off"
                  )
                  span.input-group-addon
                    i.zmdi.zmdi-phone

              v-input(:status="$v.register.country_register.$error ? 'error' : null")
                .input-group
                  the-mask.form-control(
                    :mask="['###.###.###.##']",
                    name='text',
                    type='text',
                    placeholder='CPF'
                    v-model="register.country_register"
                    autocomplete="off"
                  )
                  span.input-group-addon
                    i.zmdi.zmdi-card
              v-input(:status="$v.register.password.$error ? 'error' : null")
                .input-group
                  input.form-control(
                    type='password',
                    placeholder='Senha'
                    v-model="register.password"
                    )
                  span.input-group-addon
                    i.zmdi.zmdi-lock
              .checkbox
                input(
                  type='checkbox'
                  v-model="register.internal_regulation"
                )
                label(for='terms', @click.prevent="internalRegulation(register.internal_regulation)")
                  | Eu li e aceito os termos do &nbsp;
                  a(href='javascript:void(0);', @click.prevent="doShow()") Regimento Interno
            .footer

              a.btn.btn-primary.btn-round.btn-block(
                v-if="!register.internal_regulation"
                style="color: #fff;"
                disabled
              ) CADASTRAR

              a.btn.btn-primary.btn-round.btn-block(
                v-if="register.internal_regulation"
                @click.prevent="doRegister()"
                style="color: #fff;"
              ) CADASTRAR
            router-link.link(:to="{ name: 'auth.login'}") Você já tem cadastro?
</template>
<style scoped>
#scroll-content > div {
    background: #fff;
    height: 40px;
    margin-bottom: 5px;
    text-align: justify;
    font-size: 11px;
}
  #scroll-content > div {
      background: #c0c0c0;
      height: 40px;
      margin-bottom: 5px;
      text-align: justify;
      font-size: 11px;
  }
  #scroll-content
  {
    min-height: 400px;
    overflow: auto;
  }
.checkbox-checked input[type="checkbox"]:checked+label::after {
    border-color: #7159c1;
    background: #7159c1;
    color: white;
}
.checkbox-checked label::after {
    font-family: 'Material-Design-Iconic-Font';
    content: "\f26b";
    top: 0px;
    text-align: center;
    font-size: 14px;
    opacity: 0;
    color: #555;
    border: 0;
    background-color: inherit;
        border-color: #7159c1;
    background: #7159c1;
    color: white;
}
.color-red {
  color: #f96332;
}
.v-select .v-select-bar {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    white-space: nowrap;
    margin-bottom: calc(0px - var(--padd));
    padding-left: 7px;
    width: 100%;
}
.v-select {
    position: relative;
    outline: none;
    border: 1px solid #E3E3E3;
    border-radius: 30px;
    width: 100%;
    margin-top: 4px;
    margin-bottom: 4px;
}
.v-select {
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  font: 400 12px system-ui;
}
.v-select .v-select-bar {
    margin-top: 4px;
    margin-bottom: 4px;
}
.v-select .v-select-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: .3em .5em;
  cursor: pointer;
  margin-right: 34px;
  border-radius: 30px;
}
.v-select .v-select-selected:first-of-type {
    padding-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/app/auth/register/dweller/form.vue